// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioButton-Skeleton_cls1__ptjAV","cls2":"VeloRadioButton-Skeleton_cls2__k07CG VeloRadioButton-Skeleton_cls1__ptjAV"};